module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.ea36cd9.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Light.woff
// module id = 450
// module chunks = 1